define(function (require) {
    var $ = require('jquery');

    $('select.plan-materials-filter').change(function () {
        $('#planMaterialsFilters').submit();
    });

});